import { useFlags } from 'launchdarkly-react-client-sdk';

import useUI from 'src/hooks/use-ui';
import { COLLECTION_CHANNELS_FLAG, getCollectionChannel } from 'src/utils/collection-channel';
import type { CollectionChannel } from 'src/gql/graphql';

export function useCollectionChannel(): CollectionChannel | undefined {
  const flags = useFlags();
  const UI = useUI();

  return getCollectionChannel(UI?.variant, flags[COLLECTION_CHANNELS_FLAG] === true);
}
